import { AutogenLayoutDetentionDefinitionList } from "./autogen/AutogenLayoutDetentionDefinitionList";

export class DetentionDefinitionList extends AutogenLayoutDetentionDefinitionList {
}